import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledSelectPatientOptionWrapper = styled(Flexbox)(
    () => css`
        overflow-x: hidden;
        & b,
        & p {
            overflow-x: hidden;
            text-overflow: ellipsis;
        }
    `
)

export const StyledSelectPatientOptionPersonalData = styled(Flexbox)`
    overflow-x: hidden;
`
